if (!customElements.get('collection-load-more')) {
  class CollectionLoadMore extends HTMLElement {
    constructor() {
      super();

      this.btnLoadMore = this.querySelector('.js-btn-load-more'); /* check */
      this.productGrid = document.querySelector('#product-grid'); /* check */

      this.setProperties();
      this.toggleProductsVisibility();

      window.addEventListener('shopify:section:load', () => {
        this.setProperties();
        this.toggleProductsVisibility();
      });

      this.btnLoadMore.addEventListener('click', e => {
        e.preventDefault();

        this.btnLoadMore.setAttribute('disabled', true);

        this.loadMoreProducts();
      });

      if (this.cardText) {
        window.addEventListener('resize', () => {
          // this.setGridColsNumber();

          if (window.innerWidth < mobileWidth) {
            this.resetHiddenProducts();

            return;
          }

          this.toggleProductsVisibility();
        });
      }
    }

    setProperties() {
      this.productGrid = document.querySelector('#product-grid');
      this.cardText = this.productGrid.querySelector('.js-card-text');
      this.btnLoadMore = this.querySelector('.js-btn-load-more');
      this.hiddenProducts = [];
      this.cardTextIndexOffset = 2;
      this.isLastPage = this.classList.contains('hidden');
      this.cardProduct = document.querySelector('card-product');
      this.setGridColsNumber();
    }

    setGridColsNumber() {
      // prettier-ignore
      this.productGridCols = Math.round(this.productGrid.getBoundingClientRect().width / this.cardProduct?.getBoundingClientRect().width);
    }

    toggleProductsVisibility() {
      if (!this.cardText || this.isLastPage) {
        return;
      }

      const items = Array.from(this.productGrid.children);
      const visibleItems = items
        .filter(item => !item.classList.contains('hidden'))
        .reverse();
      const productRect = visibleItems
        .find(item => !item.classList.contains('js-card-text'))
        .getBoundingClientRect();
      const lastItem = visibleItems[0];

      const productGridRect =
        this.productGrid.getBoundingClientRect();
      const lastItemRect = lastItem.getBoundingClientRect();

      const productGridCols = Math.round(
        productGridRect.width / productRect.width
      );
      const productGridOffset =
        productGridRect.x + productGridRect.width;
      const lastItemOffset = lastItemRect.x + lastItemRect.width;

      const isLastItemCardText =
        items[items.length - 1].classList.contains('js-card-text');

      if (isLastItemCardText) {
        const prevProduct = visibleItems[1];
        const prevProductRect = prevProduct.getBoundingClientRect();
        const prevProductOffset =
          prevProductRect.x + prevProductRect.width;

        if (
          lastItemRect.y !== prevProductRect.y &&
          productGridOffset !== prevProductOffset
        ) {
          this.hiddenProducts[0].classList.remove('hidden');
          this.hiddenProducts.shift();
        }
      }

      const isLastColumn = productGridOffset === lastItemOffset;

      if (isLastColumn) {
        if (this.hiddenProducts.length >= productGridCols) {
          this.resetHiddenProducts(productGridCols);
        }

        return;
      }

      // prettier-ignore
      const gridGaps = Math.round((productGridRect.width - (lastItemOffset - productGridRect.x)) / productRect.width);

      if (this.hiddenProducts.length >= gridGaps) {
        const hiddenProductsLimit =
          this.hiddenProducts.length - gridGaps;

        this.resetHiddenProducts(hiddenProductsLimit);

        return;
      }

      let productsLooped = 0;

      for (const product of visibleItems) {
        if (product.classList.contains('js-card-text')) {
          continue;
        }

        productsLooped++;
        this.hiddenProducts.unshift(product);
        product.classList.add('hidden');

        if (productsLooped === productGridCols - gridGaps) {
          break;
        }
      }
    }

    resetHiddenProducts(limit) {
      if (!this.cardText) {
        return;
      }

      const hiddenProducts = [...this.hiddenProducts];
      let i = 0;

      for (const product of hiddenProducts) {
        i++;

        product.classList.remove('hidden');
        this.hiddenProducts.shift();

        if (limit && limit === i) {
          break;
        }
      }
    }

    async loadMoreProducts() {
      try {
        const nextPageResponse = await fetch(
          `${this.btnLoadMore.dataset.href}`
        );
        const nextPageText = await nextPageResponse.text();

        const nextPageHTML = new DOMParser().parseFromString(
          nextPageText,
          'text/html'
        );

        const productGridContainer = nextPageHTML.querySelector(
          '#ProductGridContainer'
        );
        const productGrid =
          productGridContainer.querySelector('#product-grid');
        const loadMoreContainer = productGridContainer.querySelector(
          'collection-load-more'
        );
        const btnLoadMore = loadMoreContainer.querySelector(
          '.js-btn-load-more'
        );

        const isLoadMoreHidden =
          loadMoreContainer.classList.contains('hidden');
        const products = productGrid.children;

        if (this.cardText) {
          if (this.cardTextIndexOffset > 0) {
            const productsArray = Array.from(products);
            const cardTextIndex = productsArray.findIndex(product =>
              product.classList.contains('js-card-text')
            );
            const elementAfterCardText =
              products[cardTextIndex - this.cardTextIndexOffset];

            this.cardTextIndexOffset = 0;

            if (elementAfterCardText) {
              const cardText = productsArray[cardTextIndex];

              cardText.remove();
              elementAfterCardText.insertAdjacentElement(
                'beforebegin',
                cardText
              );
            }
          } else {
            this.cardTextIndexOffset = 2;
          }
        }

        this.resetHiddenProducts();
        history.replaceState({}, '', this.btnLoadMore.dataset.href);
        this.productGrid.insertAdjacentHTML(
          'beforeend',
          productGrid.innerHTML
        );

        if (isLoadMoreHidden) {
          this.isLastPage = true;
          this.classList.add('hidden');

          return;
        }

        this.toggleProductsVisibility();
        this.btnLoadMore.dataset.href = btnLoadMore.dataset.href;
      } catch (error) {
        console.error(error);

        alert(error.message);
      } finally {
        this.btnLoadMore.removeAttribute('disabled');
      }
    }
  }

  customElements.define('collection-load-more', CollectionLoadMore);
}
;(() => {
  const VERSION = '2026-05-13-blog-filter-head-fix-v1';
  window.DJ_BLOG_FILTER_HEAD_FIX_VERSION = VERSION;

  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function initBlogFilters(scope) {
    const root = (scope || document).querySelector ? (scope || document).querySelector('.blog') : null;
    if (!root) return;
    const scroller = root.querySelector('[data-blog-filters-scroller]');
    const prev = root.querySelector('[data-blog-filters-prev]');
    const next = root.querySelector('[data-blog-filters-next]');
    if (!scroller || !prev || !next) return;

    function update() {
      const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const hasOverflow = max > 4;
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      prev.disabled = scroller.scrollLeft <= 4;
      next.disabled = scroller.scrollLeft >= max - 4;
    }

    if (root.dataset.djBlogArrowReady !== VERSION) {
      root.dataset.djBlogArrowReady = VERSION;
      prev.addEventListener('click', function () {
        scroller.scrollBy({ left: scroller.clientWidth * -0.74, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        scroller.scrollBy({ left: scroller.clientWidth * 0.74, behavior: 'smooth' });
      });
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }

    if (scroller.dataset.djReliableNavReady !== VERSION) {
      scroller.dataset.djReliableNavReady = VERSION;
      let linkPress = null;
      scroller.querySelectorAll('a').forEach(function (link) { link.setAttribute('draggable', 'false'); });
      scroller.addEventListener('pointerdown', function (event) {
        const link = event.target && event.target.closest ? event.target.closest('.blog__filters a[href]') : null;
        linkPress = link ? { href: link.href, x: event.clientX, y: event.clientY } : null;
      }, true);
      scroller.addEventListener('click', function (event) {
        const link = event.target && event.target.closest ? event.target.closest('.blog__filters a[href]') : null;
        if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
        const moved = linkPress && (Math.abs(event.clientX - linkPress.x) > 10 || Math.abs(event.clientY - linkPress.y) > 10);
        if (moved) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(link.href);
      }, true);
    }

    if (scroller.dataset.djBlogDragReady !== VERSION) {
      scroller.dataset.djBlogDragReady = VERSION;
      let isDown = false;
      let startX = 0;
      let startScrollLeft = 0;
      let didDrag = false;
      let blockClick = false;

      function finish(event) {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove('is-pointer-down', 'is-dragging');
        try {
          if (event && scroller.hasPointerCapture && scroller.hasPointerCapture(event.pointerId)) scroller.releasePointerCapture(event.pointerId);
        } catch (error) {}
        if (didDrag) {
          blockClick = true;
          window.setTimeout(function () { blockClick = false; }, 140);
        }
      }

      scroller.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDown = true;
        didDrag = false;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-pointer-down');
        try { if (scroller.setPointerCapture) scroller.setPointerCapture(event.pointerId); } catch (error) {}
      });
      scroller.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 5) {
          didDrag = true;
          scroller.classList.add('is-dragging');
        }
        if (didDrag) {
          scroller.scrollLeft = startScrollLeft - delta;
          event.preventDefault();
        }
      }, { passive: false });
      scroller.addEventListener('pointerup', finish);
      scroller.addEventListener('pointercancel', finish);
      scroller.addEventListener('pointerleave', finish);
      scroller.addEventListener('click', function (event) {
        if (!blockClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    update();
    window.setTimeout(update, 500);
    window.setTimeout(update, 1200);
  }

  function hydrateBlogHead() {
    if (window.location.pathname !== '/blogs/blog') {
      initBlogFilters(document);
      return;
    }
    const current = document.querySelector('.blog__head');
    if (!current) return;
    fetch('/blogs/blog?view=ajax&dj_blog_head=' + Date.now(), { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.blog__head');
        if (fresh) current.replaceWith(fresh);
        initBlogFilters(document);
      })
      .catch(function () { initBlogFilters(document); });
  }

  ready(hydrateBlogHead);
})();
